export default "__VITE_ASSET__CTFtTeAm__"